<template>
  <v-dialog
    :value="value"
    :max-width="maxWidth"
    persistent
    content-class="admin-dialog"
    @input="$emit('input', $event)"
  >
    <div class="admin-dialog__card">
      <h2 v-if="title" class="admin-dialog__title">{{ title }}</h2>
      <div class="admin-dialog__body">
        <slot>{{ body }}</slot>
      </div>
      <div class="admin-dialog__actions">
        <button
          type="button"
          class="admin-btn admin-btn--ghost"
          :disabled="busy"
          @click="onCancel"
        >
          {{ cancelLabel }}
        </button>
        <button
          type="button"
          :class="[
            'admin-btn',
            confirmVariant === 'danger' ? 'admin-btn--danger' : 'admin-btn--primary'
          ]"
          :disabled="busy || confirmDisabled"
          @click="$emit('confirm')"
        >
          {{ busy ? busyLabel : confirmLabel }}
        </button>
      </div>
    </div>
  </v-dialog>
</template>

<script>
/**
 * Shared confirm/info shell for admin pages (System schema apply, …).
 * Prefer this over hand-rolled sys-dialog / geo-dialog chrome.
 */
export default {
  name: 'AdminConfirmDialog',
  props: {
    value: Boolean,
    title: String,
    body: String,
    cancelLabel: { type: String, required: true },
    confirmLabel: { type: String, required: true },
    busyLabel: { type: String, required: true },
    busy: Boolean,
    confirmDisabled: Boolean,
    confirmVariant: { type: String, default: 'primary' },
    maxWidth: { type: [String, Number], default: 520 }
  },
  methods: {
    onCancel () {
      this.$emit('input', false)
      this.$emit('cancel')
    }
  }
}
</script>
